<template>
  <div>
    <van-cell-group>
      <van-field
        readonly
        clickable
        :border="false"
        :name="name"
        :value="$v.data.$model"
        :label="elemento.label"
        :placeholder="elemento.placeholder"
        @click="showCalendar = true"
      />
      <van-calendar v-model="showCalendar" @confirm="onConfirmData" :style="getStilePopup()" :show-confirm="false" :min-date="minDate" first-day-of-week="1"/>
    </van-cell-group>
      <van-cell
        readonly
        clickable
        name="datetimePicker"
        :value="ora"
        title="Orario"
        placeholder="Scegli l'orario"
        @click="showPickerOrario = true"
      />
      <van-popup v-model="showPickerOrario" position="bottom">
        <van-datetime-picker
          v-model="ora"
          type="time"
          @confirm="onConfirmOrarioPicker"
          @cancel="showPickerOrario = false"
        />
      </van-popup>
  </div>
</template>

<script>
import moment from 'moment'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  mixins: [validationMixin],
  props: {
    elemento: Object,
    minDate: Date,
    name: String
  },
  data() {
    return {
      data: '',
      ora: '',
      showCalendar: false,
      currentTime: '',
      showPickerOrario: false
    }
  },
  validations: {
    data: { required }
  },
  methods: {
    getStilePopup() {
      var cont = document.querySelector('.main-popup-report')
      if (cont) {
        return `height: "50%"; width: ${cont.offsetWidth}px`
      } else {
        return 'height: "50%";'
      }
    },
    onConfirmData(value) {
      // TODO: Verificare le validazioni
      this.data = moment(value).format('DD/MM/YYYY')
      this.showCalendar = false
      const valore = this.ora ? `${this.data} ${this.ora}` : this.data
      // this.$emit('change', this.elemento.model, this.data, value)
      this.$emit('change', this.elemento.model, valore)
    },
    onConfirmOrarioPicker(value) {
      this.showPickerOrario = false
      this.ora = value
      const valore = this.data ? `${this.data} ${this.ora}` : this.ora
      this.$emit('change', this.elemento.model, valore)
    }
  }
}
</script>
